import { EntityProfessionalRatingCommentCountDocument } from '@medprev-web-app/api-graphql-client';

import { ApolloClient } from '@/graphql/apollo-client';

export async function getProfessionalCommentCount(id: string, page: number = 1) {
  const { data } = await ApolloClient.query({
    query: EntityProfessionalRatingCommentCountDocument,
    variables: { id, page },
  });

  return data?.entityProfessionalRatingCommentCount;
}
